const EnumDic = {
  OcrmReceiptVerifyTypeEnum: {
    Init: 1, // "未送审"),
    Depart: 2, // "部门复核"),
    Ae: 3, // "业务经理审核中"),
    Company: 4, // "公司批复中"),
    Fm: 5, // "财务经理审核中"),
    Cashier: 6, // "出纳审核中"),
    Ceo: 7, // "总经理审核中"),
    CashierFinish: 8, // "出纳完成中"),
    Finish: 9, // "已完成"),
    Refuse: 10, // "审核被驳回"),
    UNKNOWN: 1000 // "未知");
  },
}

export default EnumDic